(function() {

	'use strict';

	angular.module('Services').factory('ReportingOfficeBySpendTableDataService', ReportingOfficeBySpendTableDataService);

	function ReportingOfficeBySpendTableDataService(Shipments, Carrier, TableLiteFactory, CommonService, trackingStatusesConst, toastr) {
		return function (params) {
            var ReportingOfficeBySpendTable = {
                tableName: 'ReportingOfficeBySpendTableDataService',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Office Name',
                    viewName: 'officeName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header))
                        },
                        model: ''
                    },
                    headerFn: function() {
                        sort(this.viewName);
                    }
                }, {
                    label: 'MONTH',
                    viewName: 'amountMonth',
                    /*filter: {
                        type: 'inputDropdown',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        items: [{
                            viewName: 'Month 1'
                        }, {
                            viewName: 'Month 2'
                        }],
                        onSubmit: function() {
                            console.log(this);
                        }
                    },*/
                    headerFn: function() {
                        sort(this.viewName);
                    }
                }, {
                    label: 'MONTH LAST YEAR',
                    viewName: 'comparableMonthLastYear',
                    /*filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function() {
                            console.log(this);
                        }
                    },*/
                    headerFn: function() {
                        sort(this.viewName);
                    }
                }, {
                    label: 'YEAR',
                    viewName: 'amountYear',
                    /*filter: {
                        type: 'inputDropdown',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        items: [{
                            viewName: 'Test'
                        }, {
                            viewName: 'Test2'
                        }],
                        onSubmit: function() {
                            console.log(this);
                        }
                    },*/
                    headerFn: function() {
                        sort(this.viewName);
                    }
                }, {
                    label: 'LAST YEAR',
                    viewName: 'comparableYear',
                    /*filter: {
                        type: 'inputDropdown',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        items: [{
                            viewName: 'Test'
                        }, {
                            viewName: 'Test2'
                        }],
                        onSubmit: function() {
                            console.log(this);
                        }
                    },*/
                    headerFn: function() {
                        sort(this.viewName);
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(ReportingOfficeBySpendTable,
                {
                    serviceCallback: Shipments.getOfficeBySpend,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
						company: params.companyId
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function(val) {
                    val.serviceId = val.serviceDetails ? val.serviceDetails.serviceName : 'N/A';
                    val.titleLogo = {
                        type: 'logotype',
                        imgSrc: CommonService.isContainLogo(val)
                    };
                    val.officeName = angular.getObjVal(val, 'office.name');
                    val.comparableMonthLastYear = `${CommonService.getFormattedAmount(val.comparableMonthLastYear)}`;
                    val.amountMonth = `${CommonService.getFormattedAmount(val.amountMonth)}`;
                    val.amountYear = `${CommonService.getFormattedAmount(val.amountYear)}`;
                    val.comparableYear = `${CommonService.getFormattedAmount(val.comparableYear)}`;

                    ReportingOfficeBySpendTable.data.push(val);
                    val.href= `/clients/${params.companyId}/location/${val.office.id}`;
                });
                /*** END - Building of Data ***/
            };
            this.tableData =  ReportingOfficeBySpendTable;
        };
	};
})();



// WEBPACK FOOTER //
// ./js/services/tables/ReportingOfficeBySpendTableDataService.js